import { z } from 'zod';

export const PayCorrectionChartType = z.enum(['bar', 'radar']);

export type PayCorrectionChartType = z.infer<typeof PayCorrectionChartType>;

export const PayCorrectionChartTypes = Object.values(
  PayCorrectionChartType.Values,
);
export interface DefaultCalibrationLevelDataPoint
  extends Record<string, unknown> {
  id: string;
  calibrationScore: number;
  disparity: number;
  needsAttention: number;
  avgUnderpaid: number;
  budgetNeeded: number;
  [x: string]: string | number;
}
